// Site Configurations for Novotel Store
// -- These values are unique for each site and rarely need to be changed after initial setup
// -- They are passed to the coreContext in _app.tsx and can be accessed in hah-fe-core via the useContext hook

import { UtilityIcons } from '@Hotels-at-Home/hah-fe-core/dist/types';

export const csrEmail = 'customer.service@novotelstore.com';
export const siteName = 'Novotel Store';
export const parentHotelCompany = 'Accor'; // "Accor" or "Marriott"
export const hotelBrandName = 'Novotel';
export const catalogId = 'NOV';
export const region = 'EU';

export const scandiWebMenuId = 'nov';
export const companyTelephone = '+33 1 41 51 54 24';

export const LOGO_IMAGE = { src: '/images/misc/novotel-store-logo.svg', alt: '' };

export const accorTagging = {
  accorTaggingEnabled: true,
  pageNamePrefix: 'nov',
};

// Product/Category Page Settings
// - imageWidth/imageHeight set the size of the <img /> on cat/prod pages to prevent layout shift
export const product = {
  imageWidth: 900,
  imageHeight: 525,
  imageWidthThumbnail: 500,
  ctaBlackUpsellLink: true,
  counterButtons: true,
  alignCounterWithCartBtn: true,
  itemCopyDesktop: 'accordion',
  verticalCarousel: true,
  breadCrumbPosition: 'top',
  enableAccorRewardsTab: true,
  enableShippingReturnsTab: true,
  addonModalSize: 'sm',
  stickConfigBlock: true,
  almaBanner: true,
  disableDefaultYmal: true,
};

export const category = {
  imageEagerLoadingAmount: 3,
  colorSwitcher: true,
  disableColorSwitcherImageSwitching: true,
  displayPrices: true,
  colorSwitcherMode: 'hover', // 'default' | 'click' | 'hover'
};

export const checkout = {
  radioButtons: true,
  placeholderLabels: true,
  aboveTotalsCouponCode: true,
  brandSubscribeCheckbox: true,
  accorSubscribeCheckbox: true,
  paymentMethodProceedButton: true,
};
export const footer = {
  hahSubscribeCheckbox: true,
  brandSubscribeCheckbox: true,
  accorSubscribeCheckbox: true,
  inlineSubscribeHeading: true,
};
export const header = {
  subMenuImages: true,
  subMenuImageNoWrapper: true,
  shallowMobileMenu: true,
  subMenuImageSize: {
    width: 289,
    height: 144,
  },
  subMenuExtraImageSize: {
    width: 234,
    height: 240,
  },
  textMobileMenuButton: true,
  leftDrawerUtilities: true,
};

export const notFoundPage = {
  button: true,
};

// Misc
export const firstVisitModal = {
  modalWidth: 711,
  hahSubscribeCheckbox: true,
  brandSubscribeCheckbox: true,
  accorSubscribeCheckbox: true,
};
export const iconOrder = [
  UtilityIcons.Language,
  UtilityIcons.Currency,
  UtilityIcons.Search,
  UtilityIcons.ShoppingCart,
  // UtilityIcons.Account,
];

// Adobe Launch Settings
// - Remove these lines completely if this is not a Marriott site
export const enableBonvoyNumber = false;
export const enableAccorAllNumber = true;
export const enableMarriottAdobeLaunch = false;
// export const marriottAdobeLaunchBrandCode = 'MC';
// export const marriottAdobeLaunchBrandName = 'Marriott Hotels & Resorts';

// Google Tag Manager & Analytics Settings
export const enableGoogleTagManager = true;
// GTM Owned by Accor
export const googleTagManagerId = 'GTM-WN2Z6DK';
export const productNameFilters = {
  replacements: [{ target: 'Shop Novotel Store', replacement: 'Shop' }],
  splits: [{ split: ' - ', keepIndex: 0 }],
};

// Cookie Restorer for Safari ITP
export const cookieRestorerEnabled = true;
export const cookieRestorerOptions = { options: { interval: 5000 } };

// Meta Tags
export const googleSiteVerification = 'GkFrfqfUDwWgGbEQ9lVF4EUZCxhQFVgpE-ngWnyX9Po';
export const defaultOgImage = '/images/homePage/heroSection/hp-main-hero-novotel-mobile.webp';

export const account = {
  accountGlobalEnable: true,
  disableAccountDrawer: true,
  enableLogoutBtn: true,
  enableWelcomeMessage: true,
  register: {
    hahSubscribeCheckbox: true,
    brandSubscribeCheckbox: true,
    accorSubscribeCheckbox: true,
  },
};

// We use this to calculate discount on static prices in the HP
// if a different discount needs to be applied to individual products (e.g. in variable promos) in the HP search for "static prices in EUR" and update accordingly
export const sitewideDiscount = 0.25;

export const cart = {
  counterButtons: true,
  drawerContinueShopping: true,
  useCartDrawer: true,
  staticQuantity: true,
  ymalName: 'NOV - Wishlist',
  ymalName1: 'NOV - HP',
  ymalName2: 'NOV - HP2',
  disableCartYmals: true,
  drawerTotalInBUtton: true,
};

// if the route includes the name of one object, we use this data to build page_view and userInteract events for the dataLayer
// needed for posts landing page
export const overrideDataLayerRoutes = [
  {
    name: '/articles',
    pageName: 'hub_articles',
    pageCategory: 'store',
    pageType: 'hub_articles',
    pageVirtualPath: '/hub_carticles/',
  },
  {
    name: '/posts/dreamy-sleep-and-wellness-by-novotel',
    pageName: 'hub_articles',
    pageCategory: 'store',
    pageType: 'hub_articles',
    pageVirtualPath: '/hub_carticles/',
  },
];
